import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import "./Footer.scss";
// import logoBlack from "../../Assets/Images/navLogoBlack.png";
import logo from "../../Assets/Images/logo.png";
import discordBlack from '../../Assets/Icons/blackDiscord.svg'
import twitterBlack from '../../Assets/Icons/blackTwitter.svg'
import instagramBlack from '../../Assets/Icons/blackInstagram.svg'
import discord from '../../Assets/Icons/discordLogo.svg'
import twitter from '../../Assets/Icons/twitterLogo.svg'
import instagram from '../../Assets/Icons/instagramLogo.svg'
import discordPink from '../../Assets/Icons/pinkDiscord.svg'
import twitterPink from '../../Assets/Icons/pinkTwitter.svg'
import instagramPink from '../../Assets/Icons/pinkInstagram.svg'

const Navbar = ({ homeNav }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div id="footer">
      <div className="footerContent">
        <nav className={homeNav}>
          <div className="container-fluid navbarWidth ">
            <a href="/" className='logo'>
              <img className="navlogo" src={logo} alt="logo" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={handleShow}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body>
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      activeClassName={"current"}
                      href="/#about"
                      onClick={handleClose}
                    >
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      activeClassName={"current"}
                      href="/#features"
                      onClick={handleClose}
                    >
                      Success
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      activeClassName={"current"}
                      href="/#pricing"
                      onClick={handleClose}
                    >
                      Features
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      activeClassName={"current"}
                      href="/#faq"
                      onClick={handleClose}
                    >
                      Purchase
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      activeClassName={"current"}
                      href="/#faq"
                      onClick={handleClose}
                    >
                      FAQ
                    </a>
                  </li>
                  {/* <li className="nav-item ms-md-3">
                    <a
                      className="nav-link"
                      activeClassName={"current"}
                      href="/#faq"
                      onClick={handleClose}
                    >
                      Support
                    </a>
                  </li> */}
                </ul>
                <ul className="socialContainer">
                  <li className="nav-item">
                    <a href="/">
                      <img className="socialLogo" src={discord} alt="logo" />

                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="/">
                      <img className="socialLogo" src={twitter} alt="logo" />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="/#">
                      <img className="socialLogo" src={instagram} alt="logo" />
                    </a>
                  </li>
                </ul>
              </Modal.Body>
            </Modal>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav me-auto pe-3 mt-1 mb-md-0 scrollspy">
                <li className="nav-item ms-md-3">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#about"
                  >
                    About
                  </a>
                </li>
                <li className="nav-item ms-md-3">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#success"
                  >
                    Success
                  </a>
                </li>
                <li className="nav-item ms-md-3">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#features"
                  >
                    Features
                  </a>
                </li>
                <li className="nav-item ms-md-3">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#faq"
                  >
                    Purchase
                  </a>
                </li>
                <li className="nav-item ms-md-3">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#faq"
                  >
                    FAQ
                  </a>
                </li>
                {/* <li className="nav-item ms-md-3">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#faq"
                  >
                    Support
                  </a>
                </li> */}
              </ul>
              <ul className="socialContainer">
                <li className="nav-item">
                  <a href="/">
                    <div className="socialLogoDiscord" />

                  </a>
                </li>
                <li className="nav-item">
                  <a href="/">
                    <div className="socialLogoTwitter" />
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/#">
                    <div className="socialLogoInstagram" />
                  </a>
                </li>
              </ul>
            </div>
            <form className="d-flex">
              <a href="/#plan">
                <div className="btn purchaseButton text-nowrap">Purchase Now</div>
              </a>
            </form>
          </div>
        </nav>
        <hr />
        <div className='footerBottom'>
          <div className='footerBottomLeft'>
            <a className='footerBottomText' href='/terms'>Terms of Service</a>
            <a className='footerBottomText' href='/privacy'>Privacy Policy</a>
          </div>
          <p className='footerBottomText'>©Freebie Frenzy 2022</p>
        </div>
      </div>
    </div>
  );
}

export default Navbar
